// extracted by mini-css-extract-plugin
export default {"Details":"Details_Details__+NUN6","Left":"Details_Left__yIsJB","Right":"Details_Right__vVwtV","Main":"Details_Main__t2p26","About":"Details_About__Yc+3V"};